module.exports = __webpack_public_path__ + "img/ei-close.c74067a7.svg";